import { Component, inject } from '@angular/core';
import { SaleOrderParameterValueService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  SaleOrderParameterValueCreateDto,
  SaleOrderParameterValueDto,
  SaleOrderParameterValueExcelDownloadDto,
  SaleOrderParameterValueUpdateDto,
} from '../proxy/controlling/dtos/sale-order-parameter-value';
import { SALEORDERPARAMETERVALUE_CONFIG, SALEORDERPARAMETERVALUE_FIELDS } from './sale-order-parameter-value.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-sale-order-parameter-value',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, SaleOrderParameterValueService, ConfirmationService],
  templateUrl: './sale-order-parameter-value.html',
  styleUrl: './sale-order-parameter-value.scss',
})
export class SaleOrderParameterValue extends BaseCrudComponent<
  SaleOrderParameterValueDto,
  SaleOrderParameterValueCreateDto,
  SaleOrderParameterValueUpdateDto,
  SaleOrderParameterValueExcelDownloadDto
> {
  service = inject(SaleOrderParameterValueService);
  config = SALEORDERPARAMETERVALUE_CONFIG;
  fields = SALEORDERPARAMETERVALUE_FIELDS;

  protected prepareUpdateDto(data: any, selected: SaleOrderParameterValueDto): SaleOrderParameterValueUpdateDto {
    return {
      name: data.name,
      value: data.value,
      saleOrderParameterId: data.saleOrderParameterId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'SaleOrderParameterValue';
  }
}
